import baseURL from "../common/axios";
class Commonservices {
  Create(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "SurgeryBrandModelMaster/Create",
      objinsert
    );
  }

  MappingCreate(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "SurgeryBrandModelMapping/Create",
      objinsert
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "SurgeryBrandModelMaster/Update",
      objupdate
    );
  }
  List() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("SurgeryBrandModelMaster/List");
  }
  GetById(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "SurgeryBrandModelMaster/Get?id=" + EditId + ""
    );
  }
  ListBySurgeryMasterId(SurgeryMasterId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "SurgeryBrandModelMaster/ListBySurgeryMasterId?SurgeryMasterId=" +
        SurgeryMasterId +
        ""
    );
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "SurgeryBrandModelMaster/Delete?id=" + DelID
    );
  }
  //Active
  Active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "SurgeryBrandModelMaster/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
}
export default new Commonservices();
